import { getYearsForDropDown } from "projects-new/tracking_dashboards/helperFunctions"
import moment from "moment"

const swalContents = {
    submitTrackingDashboardFailure: {
        icon: "error",
        text: "There was an error submiting your Tracking Board.",
        title: "Error",
    },
    submitTrackingDashboardPermissionDenied: {
        icon: "error",
        text: "You do not have permission to edit this Tracking board",
        title: "Error",
    },
    archiveDashboard: {
        title: "Are you sure you want to delete this Tracking Board?",
        text: "You will no longer be able to access it",
        icon: "warning",
        dangerMode: true,
        buttons: {
            cancel: "Cancel",
            confirm: {
                text: "Delete Tracking Board",
                closeModal: false,
                value: true,
            },
        },
    },
    promptDuplicate: {
        buttons: {
            cancel: "Cancel",
            confirm: {
                text: "Duplicate",
                closeModal: false,
                value: true,
            },
        },
        content: {
            element: "input",
            attributes: {
                placeholder: "Your New Tracking Board Name",
            },
        },
        title: "Name Your Duplicated Tracking Board",
        text: "An exact copy of this tracking board will be created",
        icon: "info",
    },
    failDuplicate: {
        title: "Failed to Duplicate Tracking Board",
        text: "There was issue, we're sorry.",
        icon: "error",
    },
    successDuplicate: {
        title: "Successfully Duplicated Tracking Board",
        text: "Your Tracking Board was successfully duplicated!",
        icon: "success",
        buttons: {
            cancel: "Stay",
            confirm: {
                text: "Go to New Tracking Board",
            },
        },
    },
}

export const tooltips = {
    yearTooltip: `Provide a year for your Bill Tracking Project`,
    regProposalYear: `Provide a year to track Regulations proposed within a certain year`,
    assignment: (label) => `A board of Bills organized by team member assignment`,
    issueBoard: (label) => `Issue Boards`,
    priorityBoard: (label) =>
        `A board of your ${label} organized by priority. All ${label} that you've marked as High, Medium, or Low Priority will show up here.`,
    regionWithStances: (label) =>
        `A board of your ${label} organized by region. All ${label} that you've marked as Supported, Opposed, or Watching will show up here.`,
    stanceBoard: (label) =>
        `A board of your ${label} organized by stance. All ${label} that you've marked as Supported, Opposed, or Watching will show up here.`,
    statusOpposed: (label) =>
        `A board of your ${label} organized by stance. All ${label} that you've marked as Opposed will show up here`,
    statusSupported: (label) =>
        `A board of your ${label} organized by stance. All ${label} that you've marked as Supported will show up here`,
    statusWithStances: (label) =>
        `A board of your ${label} organized by status. All ${label} that you've marked as Supported, Opposed, or Watching will show up here.`,
    regionWithPriorities: (label) =>
        `A board of your ${label} organized by region. All ${label} that you've marked as Low, Medium, or High Priority will show up here.`,
    statusHighPriority: (label) =>
        `A board of your ${label} organized by status. All ${label} that you've marked as High Priority will show up here`,
    statusWithIssues: (label) =>
        `A board of your ${label} organized by status. All ${label} that you've tagged to an issue selected in this Tracking Board will show up here.`,
    regionWithIssues: (label) =>
        `A board of your ${label} organized by region. All ${label} that you've tagged to an issue selected in this Tracking Board will show up here.`,
    searchTermBoards: (label) =>
        `Boards of auto-generating lists that match your search terms. You may select to have them be organized by stance,
        so that once you've reviewed ${label} and given them stances, they are removed from the board.`,
}

/**
 * Get a tooltip from the tooltips objects
 * @name getTooltip
 * @function
 * @param {String} tooltipName - key of the tooltip
 * @param {Number|String} dataType - Either the integer data type in the QDT, or an override label
 * @returns {String} - a Tooltip
 */
export const getTooltip = (tooltipName, dataType) => {
    let label
    if (typeof dataType === "number") {
        label = DjangIO.app.models.QuorumDataType.by_value(dataType).plural
    } else if (typeof dataType === "string") {
        label = dataType
    } else {
        label = "entity"
    }
    return tooltips[tooltipName] ? tooltips[tooltipName](label) : tooltips[tooltipName]
}

export const searchTerm = {
    description: (label) =>
        `Search Term boards help your team to find and review new ${label} that you haven't reviewed yet. ` +
        `Each search term you enter will become a separate list, and you can optionally create multiple ` +
        `Search Term boards to organize your search terms by issue. Each Search Term board is associated with its own email alert in Alert Management, so you can choose to receive alerts at different frequencies for each board.`,
}

const startDate = moment().subtract(1, "days").endOf("day").format("YYYY-MM-DD HH:mm:ss")
export const articleGlobalDefault = {
    filters: [
        {
            archived: false,
            dehydrate_extra: ["priority", "stance"],
            estimated_published_date__gt: startDate,
            language: DjangIO.app.document.types.Language.english.value,
        },
    ],
    qdt: DjangIO.app.models.QuorumDataType.media.value,
}

// form constants
export const formName = "trackingDashboardForm"

// because of prefiling, get the next year when it enters July of the current year
// this works for both Bill and Regulation
export const DEFAULT_TRACKING_YEAR = () =>
    new Date().getMonth() > 5 ? new Date().getFullYear() + 1 : new Date().getFullYear()

export const YEARS = () => getYearsForDropDown(DEFAULT_TRACKING_YEAR())
export const ALL_YEARS = "All Years"

export const getCurrentYear = () => new Date().getFullYear()
// analyze terms for the previous year
export const getYearForAnalyze = () => getCurrentYear() - 1

export default swalContents
